export const API_URLS = {
    API_STATUS: 'api/v1/status',
    TIME: 'api/v1/time',
    LOGIN: 'api/v1/user/login',
    REFRESH_TOKEN: 'api/v1/user/refresh-token',
    USER: 'api/v1/user/',
    UPDATE_USER: 'api/v1/user/updateUser',
    CHANGE_USER_NAME: 'api/v1/user/changeUserName',
    UPDATE_USER_AGE: 'api/v1/user/updateUserAge',
    GET_ALL_USERS: 'api/v1/user/fetch-all-user',
    RESET_PROGRESS: 'api/v1/user/reset-progress',
    GET_USER_DETAIL: 'api/v1/user/getUserDetail',
    GET_FRIEND_LIST: 'api/v1/user/getFriendList',
    GET_FRIEND_PROGRESS: 'api/v1/user/getFriendProgress',
    GET_PROFILE_IMAGE: 'api/v1/user/getUserProfileImages',
    UPDATE_FCM_TOKEN: 'api/v1/user/update-fcm-token',
    GET_USER_PROGRESS_DETAILS: 'api/v1/user-progress-detail/getUserProgressDetails',
    UPDATE_DATA_AFTER_TUTORIAL: 'api/v1/user-progress-detail/updateDataAfterTutorial',
    UPDATE_TUTORIAL_STEP: 'api/v1/user-progress-detail/updateTutorialStep',
    UPDATE_COINS: 'api/v1/user-progress-detail/incrementCoins',
    ADJUST_STRENGTH: 'api/v1/user-progress-detail/adjustStrength',
    CLAIM_JOURNEY_REWARD: 'api/v1/user-progress-detail/claimJourneyReward',
    UPDATE_GEMS: 'api/v1/user-progress-detail/updateGems',
    CLAIM_GEM_PASS_REWARD: 'api/v1/user-progress-detail/claimGemPassReward',
    ACKNOWLEDGE_NEW_SEASON: 'api/v1/user-progress-detail/acknowledgeNewSeason',
    GET_GAME_PHASE: 'api/v1/game/getGamePhase',
    GET_BEST_MOVE: 'api/v1/game/getBestMove',
    GET_MAIA3_MOVE: 'api/v1/game/getMaia3Move',
    GET_PATH_FINDER_MOVE: 'api/v1/game/getPathFinderMove',
    GET_GAME_DETAIL: 'api/v1/game/getGameDetail',
    SYNC_ARMY: 'api/v1/army/syncArmy',
    GET_ARMY: 'api/v1/army/getArmy',
    UPDATE_HERO_SLOT: 'api/v1/army/updateHeroSlot/',
    REMOVE_HERO: 'api/v1/army/removeHero/',
    UPGRADE_HERO: 'api/v1/army/upgradeHero',
    GET_UPGRADEABLE_HERO_POWERS: 'api/v1/army/getUpgradeableHeroPowers',
    UPDATE_IS_NEW: 'api/v1/army/updateIsNew',
    GET_BOARD_DATA: 'api/v1/army/getBoardData',
    GET_JOURNEY: 'api/v1/journey/',
    GET_TUTORIALS: 'api/v1/tutorial',
    GET_PUZZLES: 'api/v1/puzzles',
    COMPLETE_PUZZLE: 'api/v1/puzzles/complete',
    SHOP: 'api/v1/shop',
    BUY_SHOP_ITEM: 'api/v1/shop/buy-shop-item',
    TREATS: 'api/v1/treats',
    HERO_SHARD_OFFERS: 'api/v1/hero-shard-offers',
    BUY_HERO_SHARDS: 'api/v1/hero-shard-offers/buyHeroShards',
    GEM_PASSES: 'api/v1/gem-pass',
    GET_INITIAL_USER_SLOTS: 'api/v1/user-slots',
    UPDATE_USER_SLOTS: 'api/v1/user-slots/update-user-slot',
    GET_HEROES: 'api/v1/heroes/all',
    GET_ORDER_SIGNATURE_DATA: 'api/v1/in-app-purchase/getOrderSignatureData',
    IN_APP_PURCHASE: 'api/v1/in-app-purchase',
    GET_RANKINGS: 'api/v1/rankings/',
    CLAIM_RANKINGS_REWARD: 'api/v1/rankings/claimReward',
    GET_TOURNAMENT: 'api/v1/tournament/',
    CLAIM_TOURNAMENT_REWARD: 'api/v1/tournament/claimReward',
    JOIN_TOURNAMENT: 'api/v1/tournament-users/join',
    CHECK_JOINED: 'api/v1/tournament-users/check-status',
    GET_TOURNAMENT_STANDINGS: 'api/v1/tournament-users/',
    MARK_AS_ZEALY_USER: 'api/v1/zealy/mark-as-zealy-user',
    PARENTAL_CONTROLS: 'api/v1/parental-controls/',
    SUBMIT_SUPPORT_MESSAGE: 'api/v1/support/message',
    NEXT_TICKET_IN_TWO_MINUTES: 'api/v1/debug/next-ticket-in-two-minutes',
    APP_CONFIG: 'api/v1/app-config',
    GET_ASSETS_URLS: 'api/v1/urls',
    LAST_All_UPDATED_DATE: 'api/v1/last-update',
    OPENING_CHILDREN: 'api/v1/opening/children',
    OPENING_PATHS: 'api/v1/opening/paths',
    OPENING_SEARCH: 'api/v1/opening/search',
    USER_SIGNUP: 'api/v1/user/signup',
    TOURNAMENT_BASE: 'api/v1/tournament',
    ADMIN_USER_DETAIL: 'api/v1/user/userDetail',
    ADMIN_USER_PROGRESS: 'api/v1/user-progress-detail/userProgress',
    ADMIN_UPDATE_PROGRESS: 'api/v1/user-progress-detail/admin/updateProgress',
    ADMIN_UPDATE_USER: 'api/v1/user/admin/updateUser',
    ADMIN_RESET_USER: 'api/v1/user/admin/reset-user',
    ADMIN_RESET_ALL_USERS: 'api/v1/user/admin/reset-all-users',
    ADMIN_DESTROY_USER: 'api/v1/user/admin/destroyUser',
    ADMIN_CLEAR_USER_GEM_PASS: 'api/v1/user/admin/clearUserGempass',
    ADMIN_GAMES_HISTORY: 'api/v1/games-history',
    ADMIN_USER_ARMY: 'api/v1/army/userArmy',
    ADMIN_USE_HERO: 'api/v1/army/useHero/',
    ADMIN_SYNC_ARMY: 'api/v1/army/admin/syncArmy',
    ADMIN_ADD_HEROES: 'api/v1/army/admin/addNew',
    ADMIN_DELETE_ARMY_HERO: 'api/v1/army/admin/delete',
    ADMIN_API_ANALYTICS: 'api/v1/api-analytics',
    ADMIN_HEROES: 'api/v1/heroes',
    ADMIN_UPDATE_HERO: 'api/v1/heroes/update-hero',
    ADMIN_URLS_COMPARE: 'api/v1/admin/urls/compare-and-update',
    ADMIN_SYNC_CAPABILITIES: 'api/v1/admin/sync/capabilities',
    ADMIN_SYNC_CONTENT_FROM_SOURCE: 'api/v1/admin/sync/content',
    ADMIN_SYNC_ASSETS_FROM_SOURCE: 'api/v1/admin/sync/assets',
    ADMIN_RECONCILIATION: 'api/v1/admin/reconciliation',
    ADMIN_RECONCILIATION_SUMMARY: 'api/v1/admin/reconciliation/summary',
    ADMIN_PUZZLES: 'api/v1/admin/puzzles',
    ADMIN_PUZZLES_BULK: 'api/v1/admin/puzzles/bulk'
};
export const API_BASE = '/api/v1';
export const API_BASES = {
    STATUS: `${API_BASE}/status`,
    TIME: `${API_BASE}/time`,
    WEBHOOK: `${API_BASE}/webhook`,
    AUTH: `${API_BASE}/auth`,
    USER: `${API_BASE}/user`,
    USER_ADMIN: `${API_BASE}/user/admin`,
    DEBUG: `${API_BASE}/debug`,
    USER_PROGRESS_DETAIL: `${API_BASE}/user-progress-detail`,
    ARMY: `${API_BASE}/army`,
    HEROES: `${API_BASE}/heroes`,
    GAMES_HISTORY: `${API_BASE}/games-history`,
    GAME: `${API_BASE}/game`,
    IN_APP_PURCHASE: `${API_BASE}/in-app-purchase`,
    URLS: `${API_BASE}/urls`,
    ADMIN_URLS: `${API_BASE}/admin/urls`,
    ADMIN_SYNC: `${API_BASE}/admin/sync`,
    ADMIN_RECONCILIATION: `${API_BASE}/admin/reconciliation`,
    ADMIN_PUZZLES: `${API_BASE}/admin/puzzles`,
    OPENING: `${API_BASE}/opening`,
    API_ANALYTICS: `${API_BASE}/api-analytics`,
    JOURNEY: `${API_BASE}/journey`,
    GEM_PASS: `${API_BASE}/gem-pass`,
    SHOP: `${API_BASE}/shop`,
    TREATS: `${API_BASE}/treats`,
    TUTORIAL: `${API_BASE}/tutorial`,
    PUZZLES: `${API_BASE}/puzzles`,
    LAST_UPDATE: `${API_BASE}/last-update`,
    HERO_SHARD_OFFERS: `${API_BASE}/hero-shard-offers`,
    USER_SLOTS: `${API_BASE}/user-slots`,
    ZEALY: `${API_BASE}/zealy`,
    PARENTAL_CONTROLS: `${API_BASE}/parental-controls`,
    SUPPORT: `${API_BASE}/support`,
    RANKINGS: `${API_BASE}/rankings`,
    TOURNAMENT_USERS: `${API_BASE}/tournament-users`,
    TOURNAMENT: `${API_BASE}/tournament`,
    APP_CONFIG: `${API_BASE}/app-config`
};
//# sourceMappingURL=routes.js.map